import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";

const SiftedTakeCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  return (
    <CardContainer id={`content__${id}`}>
      <Heading text={briefing.siftedTakeHeading} id={id} />
      <div className="mt-[14px] bg-[#F8F7F9] py-[22px] px-[16px]">
        <p className="text-[21px] font-[600] text-[#002EA5] md:text-[21px]">
          {briefing.siftedTake}
        </p>
      </div>
    </CardContainer>
  );
};

export default SiftedTakeCard;
